/**
 * Canonical navigation vocabulary. Web's nav registry types its `key`
 * fields against ModuleKey, so an unknown key fails to compile; a test
 * in web asserts the reverse — every key here is actually rendered.
 *
 * The vocabulary is core's own keys plus whatever the sector modules
 * contribute. Keeping the two apart is what lets a module be removed and
 * take its keys with it.
 */
import { MODULE_CONTRIBUTED_KEYS } from "../modules/keys.js";
const BASE_MODULE_KEYS = [
    "accounting-aged-balance",
    "accounting-analytic-axes",
    "accounting-analytic-balance",
    "accounting-assets",
    "accounting-auxiliaries",
    "accounting-auxiliary-balance",
    "accounting-budget-vs-actual",
    "accounting-budgets",
    "accounting-chart",
    "accounting-closing",
    "accounting-cost-centers",
    "accounting-dashboard",
    "accounting-depreciations",
    "accounting-entries",
    "accounting-exchange-rates",
    "accounting-general-ledger",
    "accounting-journal-report",
    "accounting-lettering",
    "accounting-liasse-esintax",
    "accounting-periods",
    "accounting-reconciliation",
    "accounting-settings",
    "accounting-settings-smt",
    "accounting-smt",
    "accounting-statements",
    "accounting-supporting-documents",
    "accounting-trial-balance",
    "accounting-vat",
    "accounting",
    "achats",
    "admin",
    "articles",
    "audit",
    "billing",
    "budget-commitments",
    "budget-envelopes",
    "budget-execution",
    "budget-ordonnancement",
    "budget-visas",
    "budget",
    "cabinet-dossiers",
    "cabinet-settings",
    "cabinet",
    "catalogue",
    "clients-crm",
    "clients",
    "crm-activities",
    "crm-leads",
    "crm-opportunities",
    "dashboard",
    "declarations-calendar",
    "declarations-list",
    "erp-connection",
    "establishments",
    "fiscalite",
    "funding",
    "h-acces",
    "h-etats",
    "h-immos",
    "h-integrations",
    "h-pilotage",
    "h-referentiel",
    "h-saas",
    "h-saisie",
    "h-structure",
    "hr-employees",
    "hr-leaves",
    "hr-payroll-parameters",
    "hr-payroll",
    "hr",
    "import-costs",
    "imports",
    "invoices",
    "main",
    "mcf-signatures-en-doute",
    "node-health",
    "onboarding",
    "pispi-events",
    "pos",
    "projects-list",
    "projects",
    "purchase-orders",
    "reporting-donor",
    "reporting",
    "reports-hub",
    "reports-fiscal",
    "reports",
    "roles",
    "sales-delivery-notes",
    "sales-quotes",
    "sales-recurring",
    "sales-reminders",
    "settings",
    "smt",
    "depots",
    "inventories",
    "stock",
    "supplier-invoices",
    "suppliers",
    "users",
    "ventes-caisse",
    "verification",
    "webhooks",
];
export const MODULE_KEYS = [
    ...BASE_MODULE_KEYS,
    ...MODULE_CONTRIBUTED_KEYS,
];
export function isModuleKey(value) {
    return MODULE_KEYS.includes(value);
}
//# sourceMappingURL=modules.js.map